import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';
import { TranslateService } from '@ngx-translate/core';
import { ComboServices } from '../../../combo/services';
import { StaticsServices } from '../../../services/statics';

/**
 * Component que devuelve un datetime segun lugar (espana - usa)
 *
 */

@Component({
  selector: 'combo-edit-name',
  templateUrl: 'combo-edit-name.html',
})
export class ComboEditNamePage {

  combo_uid: any = '';
  reference: any = '';
  title_es: any = '';
  title_en: any = '';
  title_fr: any = '';
  title_de: any = '';
  title_it: any = '';
  title_ca: any = '';
  subtitle_es: any = '';
  subtitle_en: any = '';
  subtitle_fr: any = '';
  subtitle_it: any = '';
  subtitle_de: any = '';
  subtitle_ca: any = '';
  tags: any = '';

  constructor(public dishServices: DishServices,
    public globals: Globals,
    public viewCtrl: ViewController,
    public translate: TranslateService,
    public comboServices: ComboServices,
    public navParams: NavParams,
    public staticsServices: StaticsServices) {

    this.combo_uid = this.navParams.get('combo_uid');
    this.reference = this.navParams.get('reference');
    this.title_es = this.navParams.get('title_es');
    this.title_en = this.navParams.get('title_en');
    this.title_fr = this.navParams.get('title_fr');
    this.title_de = this.navParams.get('title_de');
    this.title_it = this.navParams.get('title_it');
    this.title_ca = this.navParams.get('title_ca');
    this.subtitle_es = this.navParams.get('subtitle_es');
    this.subtitle_en = this.navParams.get('subtitle_en');
    this.subtitle_fr = this.navParams.get('subtitle_fr');
    this.subtitle_it = this.navParams.get('subtitle_it');
    this.subtitle_de = this.navParams.get('subtitle_de');
    this.subtitle_ca = this.navParams.get('subtitle_ca');
    this.tags = this.navParams.get('tags');
  }

  close() {
    this.viewCtrl.dismiss();
  }

  onChange(val) {
    this.tags = val;
  }

  addTag(tag) {
    if (!(this.tags.indexOf(tag) > -1)) {
      if (tag != 'eti') {
        this.tags.push(tag);
      }
    }
  }

  async updateComboName() {
    //this.globals.GAtrackView('Combo', 'Combo - Name - Update', this.globals.restaurant.email, 'Create/Update', 'Update name', 'Combo', this.title_es);
    this.comboServices.afs.collection('menus').doc(this.combo_uid).update({
      'reference': this.reference,
      'title_es': this.title_es,
      'title_en': this.title_en,
      'title_fr': this.title_fr,
      'title_de': this.title_de,
      'title_it': this.title_it,
      'title_ca': this.title_ca,
      'subtitle_es': this.subtitle_es,
      'subtitle_en': this.subtitle_en,
      'subtitle_fr': this.subtitle_fr,
      'subtitle_it': this.subtitle_it,
      'subtitle_de': this.subtitle_de,
      'subtitle_ca': this.subtitle_ca,
      'updated_at': new Date(),
      'tags': this.tags,
      'tags_static': this.tags.toString(),
    }).then(() => {
      //statics
      this.staticsServices.changeStateStaticWait(true);
      //pop
      this.close();
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/components/popups/combo-edit-name/combo-edit-name.ts